const breadcrumbPrint = () => {
  let res = 0
  const breadcrumbList = $('.js-breadcrumb').find('li')
  const listLength = breadcrumbList.length - 1

  breadcrumbList.each((index, item) => {
    res += Math.round($(item).width())
  })

  breadcrumbList.each((index, item) => {
    if (window.innerWidth < res) {
      if (index !== 0 && index !== listLength) {
        if (index === listLength - 1) {
          $(item).find('a')[0].innerHTML = '...'
        } else {
          item.remove()
        }
      }
    }
  })
}

if (!document.querySelector('.news-breadcrumbs')) {
  $(window).on('load resize', function() {
    breadcrumbPrint()
  })
}
